import React, { PureComponent } from "react";
import { wire } from "react-hot-wire";
import { WithTranslation, withTranslation } from "react-i18next";

import CircularProgress from "@material-ui/core/CircularProgress";

import { SiteService } from "services/site/Site.service";

import { Deployment } from "models/application/Deployment";
import { Application } from "models/application/Application";

export class DeploymentLogs extends PureComponent<
  {
    siteService: SiteService;
    application: Application;
    setApplicationState: Function;
  } & WithTranslation
> {
  private __cachedPolling: number = 0;
  private unregisterScrollListener: () => void = () => {};
  private isMoving: boolean = false;
  private logs = React.createRef<HTMLDivElement>();

  state: { deployment?: Deployment | null } = {
    // undefined value is used for detect "request-end" process
    deployment: undefined
  };

  render() {
    const { t } = this.props;
    const { deployment } = this.state;

    return (
      <div
        className="modal-body overflow-auto"
        style={{ height: 0 }}
        ref={this.logs}
      >
        {deployment === undefined ? (
          <div className="d-flex align-items-center justify-content-center h-100">
            <CircularProgress />
          </div>
        ) : (
          <pre style={{ whiteSpace: "pre-wrap" }}>
            {deployment && deployment.job.log
              ? deployment.job.log
              : t("application.preview.emptyLogs")}
          </pre>
        )}
      </div>
    );
  }

  componentDidMount() {
    this.fetchJob().then(() => {
      // first, move to the last log message
      this.logs.current!.scrollTop = this.logs.current!.scrollHeight;
    });
    this.unregisterScrollListener = this.registerScrollListener();
  }

  private async fetchJob() {
    const { siteService, application, setApplicationState } = this.props;
    const {
      latestDeployment
    }: { latestDeployment?: Deployment } = await siteService.fetchApplication({
      application
    });

    return new Promise<void>(resolve =>
      this.setState(
        {
          deployment: latestDeployment
        },
        resolve
      )
    ).then(() => {
      setApplicationState(
        latestDeployment
          ? this.jobState(latestDeployment.job.state)
          : this.jobState(this.props.application.status)
      );

      // run polling (request, refresh etc.) process only in the "in-progress" state
      if (latestDeployment && latestDeployment.job.state === "in-progress") {
        this.runPollingProcess();
      }
    });
  }

  private runPollingProcess() {
    if (!this.isMoving) {
      this.logs.current!.scrollTop = this.logs.current!.scrollHeight;
    }

    this.__cachedPolling = window.setTimeout(() => this.fetchJob(), 1000);
  }

  private jobState(state: string) {
    return (
      <span className="badge badge-warning mr-2">
        {this.props.t(`application.preview.status.${state}`)}
      </span>
    );
  }

  private registerScrollListener() {
    const logContainer = this.logs.current!;

    const listener = () => {
      const { scrollHeight, scrollTop, offsetHeight } = this.logs.current!;

      this.isMoving = scrollHeight - (scrollTop + offsetHeight) > 0;
    };

    logContainer.addEventListener("scroll", listener);

    return () => window.removeEventListener("scroll", listener);
  }

  componentWillUnmount() {
    this.unregisterScrollListener();
    window.clearTimeout(this.__cachedPolling);
  }
}

export default wire(["siteService"], withTranslation()(DeploymentLogs));
